import { Observable, Subject } from 'rxjs';
import { share, takeUntil } from 'rxjs/operators';

import { Component, Inject, ChangeDetectionStrategy, Input, OnDestroy } from '@angular/core';

import { SnStreamSources } from '@lib/api/entities';

import { ISnPlayer } from '../../interfaces';

@Component({
  selector: 'sn-player-source-toggle-control',
  templateUrl: './player-source-toggle.control.html',
  styleUrls: ['./player-source-toggle.control.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SnPlayerSourceToggleControl implements OnDestroy {
  @Input()
  public liveUrls: string | SnStreamSources;

  private readonly _destroy$ = new Subject();

  constructor(@Inject('SN_PLAYER') private readonly _player: ISnPlayer) {}

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  get live$(): Observable<boolean> {
    return this._player.live$.pipe(takeUntil(this._destroy$), share());
  }

  public toggle(): void {
    const live = this._player.live;
    if (!this.liveUrls || live) {
      return;
    }

    if (!this._player['isBosch']) {
      this._player.src = this.liveUrls;
    }
    this._player.live = !live;
  }
}
